module.exports = __webpack_public_path__ + "static/media/program.cd776b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/program.png
// module id = 1256
// module chunks = 0